import Particle from '../components/Particle'

const HeroSection = () => {
  return (
    <section id="hero" className="bg-blue-500 text-white h-screen flex items-center justify-center relative pt-16">
      <div className="absolute inset-0 overflow-hidden">
        <Particle />
      </div>
      <div className="container mx-auto text-center relative z-9" data-aos="fade-up">
        <h1 className="text-5xl md:text-7xl font-bold mb-4">Welcome to Max Hauling</h1>
        <p className="text-xl md:text-2xl mb-8">Your reliable junk hauling service</p>
        <a href="#how-it-works">
          <button className="bg-black text-white py-2 px-4 rounded hover:bg-blue-700">
            Get Started
          </button>
        </a>
      </div>
    </section>
  );
};

export default HeroSection;